import React from 'react';
import { factory } from '../positions/asset-position-details/asset-position-details-container';
import AssetPositionDetails from '../positions/asset-position-details/asset-position-details';

function BondsAssetPositionDetails(props) {
  return (<AssetPositionDetails
    {...props}
    renderBottomSeparator={true}
    row={Object.assign({}, props.row, {
      accruedInterestUnit: props.referenceCurrency,
    })}
  />);
}

export default factory({
  component: BondsAssetPositionDetails,
  rowFragmentExtend: {
    accruedInterest: true,
    rating: true,
  },
  mapperExtend: ({ currency }) => ({
    accruedInterestUnit: currency,
  }),
});
